/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import moment from "moment-timezone";

import { getPages, deletePages } from '../../api/pagesApi';

import TopBar from '../../components/TopBar'
import { DataTableList } from '../../components/DataTable/DataTableList';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';
import { pageStatus } from '../../utils/constants';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import searchIcon from "../../assets/images/icon-search.svg";
import down from "../../assets/images/icondropdown.svg";

import styles from './page.module.css'

const AllPages = () => {
    const popupRef = useRef()
    const statusDropdownRef = useRef();

    const [pageList, setPagesList] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [openStatus, setOpenStatus] = useState(false);
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    const fetchData = async () => {
        try {
            setIsLoadingData(true);
            const response = await getPages({
                page: currentPage,
                search: searchInput,
                status: selectedStatuses?.join(',') || "",
                sortBy: 'createdAt',
            });

            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false);
            }
            setPagesList(response?.data?.result || []);
            setTotalPage(response?.data?.totalPages || 1);
        } catch (error) {
            console.error('Error loading pages:', error);
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, selectedStatuses]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setOpenStatus(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = pageList?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = Math.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (pageList?.length > 0) {
            calculateColumnWidths();
        }
    }, [pageList]);

    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            const selectableRows = pageList?.filter(row => row?.slug !== 'home' && row?.slug !== 'blogs') || [];
            const selectableIds = selectableRows.map(row => row?.pageId).filter(id => id);
            setSelectedRows(selectableIds);
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleSearch = async () => {
        fetchData();
    }

    const handleStatusChange = (status) => {
        setSelectedStatuses(prev => {
            if (prev.includes(status)) {
                const filtered = prev.filter(s => s !== status);
                return filtered.length === 0 ? [] : filtered;
            } else {
                return prev?.length === 0
                    ? [status]
                    : [...prev, status];
            }
        });
    }

    const columns = [
        {
            name: 'Title',
            selector: (row) => row?.title,
            cell: (row) => <div className='editTitle'><Link to={`/page/${row?.pageId}`}>{row?.title}</Link></div>,
            sortable: true,
            minWidth: columnWidths['title'] ? `${parseInt(columnWidths['title']) + 50}px` : '200px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => (
                <span className={`status-badge ${row.status}`}>
                    {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
                </span>
            ),
            sortable: true,
            width: '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Date',
            selector: (row) => row?.createdAt,
            cell: (row) => <div>{moment(row.createdAt).tz("Asia/Kolkata").format("MMM DD, YYYY")}</div>,
            sortable: true,
            width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 120}px` : '200px',
            style: { width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 120}px` : '200px', paddingTop: "15px", paddingBottom: "15px", fontSize: "14px", paddingLeft: 0 },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <Link to={`/page/${row?.pageId}`}><button className="edit-btn"><img src={penIcon} alt="pen-icon" /></button></Link>

                    <button className="delete-btn" onClick={() => {
                        if (row?.slug !== 'home' && row?.slug !== 'blogs') {
                            setDeleteTarget({ type: "single", row });
                            setShowDeletePopup(true);
                        }
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            if (deleteTarget.type === "single") {
                const response = await deletePages([deleteTarget?.row?.pageId]);
                if (response?.success) {
                    await fetchData()
                }
            }

            if (deleteTarget.type === "multiple") {
                const response = await deletePages(deleteTarget?.rows);
                if (response?.success) {
                    await fetchData()
                }
            }
        } catch (error) {
            console.log('Error deleting pages:', error);
            // Handle error (show notification, etc.)
        }
        setSelectedRows([]);
        setIsAllSelected(false);
        setToggleSelect(prev => !prev);

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    return (
        <div className={`${styles.pageList} ${pageList?.length <= 10 && `${styles.pageListHeight}`}`}>
            <TopBar />
            <div className={`${styles.pageDatatableList}`}>
                <div className={`${styles.pageHeader}`}>
                    <div className={`${styles.leftSide}`}>
                        <div className={`${styles.searchBar}`}>
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search pages..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <button className={`${styles.addBtn}`} onClick={() => handleSearch()}>Search</button>
                    </div>
                    <div className={`${styles.actionButtonsDeleteAdd}`}>
                        <div className="dropdown-wrapper order-status-dropdown" ref={statusDropdownRef}>
                            <div className="dropdown-header " onClick={() => setOpenStatus(!openStatus)}>
                                <span className="title">Status</span>
                                <span className={`arrow ${openStatus ? "rotate" : ""}`}><img src={down} alt='down-icon'/></span>
                            </div>
                            {openStatus && (
                                <div className="dropdown-list" >
                                    {Object.entries(pageStatus).map(([key, label]) => (
                                        <label key={key} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                checked={selectedStatuses.includes(key)}
                                                onChange={() => handleStatusChange(key)}
                                            />
                                            <span>{label}</span>
                                        </label>
                                    ))}

                                </div>
                            )}
                        </div>
                        <Link to='/new-page'><button className={`${styles.addBtn}`}>Add Page</button></Link>
                        {selectedRows?.length > 0 && (
                            <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${pageList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={pageList}
                         onSelectedRowsChange={({ selectedRows }) => {
                             const selectedIds = selectedRows.map((row) => row?.pageId);
                             const selectableRows = pageList.filter(row => row.slug !== 'home' && row.slug !== 'blogs');
                             setSelectedRows(selectedIds);
                             setIsAllSelected(selectedIds.length === selectableRows.length && selectableRows.length > 0);
                         }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        selectableRowDisabled={(row) => row.slug === 'home' || row.slug === 'blogs'}
                         progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={popupRef}
                title={deleteTarget?.type === "single" ? 'page' : selectedRows?.length === 1 ? 'page' : `pages`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.title}?` : selectedRows?.length === 1 ? `Are you sure you want to delete page?` : `Are you sure you want to delete ${selectedRows?.length} pages?`}
                confirmDelete={confirmDelete}
            />
        </div>
    )
}

export default AllPages
